@let branchInfo = branchData();
@let locationsList = branchLocations();

@if (!branchInfo || isLoading()) {
  <app-pan-blank-slate>
    <app-pan-spinner></app-pan-spinner>
  </app-pan-blank-slate>
} @else if (isAccessSuspended()) {
  <app-pan-inline-alert type="warning" class="mb-4">
    Access to this branch is suspended. Please reach out to support&#64;panoptyc.com to restore access.
  </app-pan-inline-alert>

  @if (branchInfo.stripe_customer_id) {
    <app-pan-action-bar>
      <app-pan-button color="primary" panRole [roles]="['admin', 'branch-owner', 'branch-manager']" (click)="manageBilling()">
        Manage Billing
      </app-pan-button>
    </app-pan-action-bar>
  }
} @else if (locationsList.length === 0) {
  <app-pan-blank-slate> This branch has no locations. </app-pan-blank-slate>
} @else if (isSavingPlans()) {
  <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Currently saving plan changes... </app-pan-blank-slate>
} @else {
  <app-pan-action-bar>
    <ol class="inline-flex items-center space-x-1 md:space-x-2">
      @if (!isEditingPlans()) {
        @if (showViewBilling()) {
          <li>
            <a
              panButton
              color="info"
              [routerLink]="['/home', 'manage', 'branch', branchInfo.id]"
              [queryParams]="{ subpage: 'billing-history' }"
              panRole
              [roles]="['admin', 'branch-owner', 'branch-manager']"
            >
              View Billing
            </a>
          </li>
        }

        @if (branchInfo.stripe_customer_id) {
          <li>
            <app-pan-button color="primary" panRole [roles]="['admin', 'branch-owner', 'branch-manager']" (click)="manageBilling()">
              Manage Billing
            </app-pan-button>
          </li>
        }

        <li>
          <a
            panButton
            color="primary"
            panRole
            [roles]="['admin', 'branch-manager', 'branch-owner', 'market-manager']"
            [routerLink]="['/home', 'manage', 'branch', branchInfo.id]"
            [queryParams]="{ subpage: 'shrink' }"
          >
            Manage Shrink
          </a>
        </li>
      }

      @if (showEditPlans()) {
        @if (isEditingPlans()) {
          <li>
            <app-pan-button color="primary" (click)="savePlans()"> Save Plans </app-pan-button>
          </li>

          <li>
            <app-pan-button color="default" (click)="cancelPlanEdit()"> Cancel Edit </app-pan-button>
          </li>
        } @else {
          <li>
            <app-pan-button color="warning" (click)="editPlan()" [disabled]="isLoading()"> Edit Plans </app-pan-button>
          </li>
        }
      }
    </ol>
  </app-pan-action-bar>

  @if (presenceData()[0] && presenceData()[0]?.includes(branchInfo.id.toString()) && presenceData()[1]?.length > 1) {
    <app-pan-inline-alert type="danger" class="my-2">
      Someone else is editing the plans on this branch. Your changes may not save, and you may need to refresh the page to see the new
      plans.
    </app-pan-inline-alert>
  }

  @let totalLocations = branchLocations().length;
  @let completeLocations = numCompleteLocations();

  @if (completeLocations < totalLocations) {
    <app-pan-inline-alert type="info" class="my-2">
      You have {{ completeLocations }} out of {{ totalLocations }} locations filled out. Help us cut your shrink and build your location
      profiles!
    </app-pan-inline-alert>
  }

  <div>
    <ag-grid-angular [rowData]="branchLocations()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>
  </div>
}
